import React, {useState, useEffect, useCallback} from 'react';
import {useHistory} from 'react-router-dom'
import NewPassword from './NewPassword'
import Tick from '../../../Assets/Images/tick.png'
import GetEmail from './Email'
import {encryptPassword} from '../../../Utils/Crypto'
import axios from 'axios'
import { showToast } from '../../../Component/Toast';
import Spinnner from '../../../Component/Loader'
import useClientHook from "../../../Hooks/useClientHook";
import useAdminHook from "../useAdminHook";

function Index() {
    const params = new URLSearchParams(window.location.search)
    const HISTORY = useHistory();
    const URLS = useAdminHook()
    const [Stage, setStage] = useState(undefined);
    const [Email, setEmail] = useState(params.get('email'));
    let {client_id, origin} = useClientHook('ADMIN');

    const sendOTP = useCallback((email) => {
      if(!client_id){
        return
      }
      axios.post(URLS.otp, {email, client_id}).then(res => {
            if(res){
                showToast({
                    type: 'success',
                    message: "OTP sent to your registered mail or phone"
                })
                setStage('PASSWORD')
                setEmail(email)

            }
        }).catch(err => {
            if(err.response){
                showToast({
                    type: 'error',
                    message: err.response.data.message
                })
            }else if(err.request){
                let msg = JSON.parse(err.request.response)
                showToast({
                    type: 'error',
                    message: msg.message
                })
            }

            HISTORY.push(`admin/reset?origin=${origin}`)
            setStage('EMAIL')
            setEmail(undefined);

        })
    },[HISTORY, client_id, origin,URLS.otp])

    useEffect(() => {
      if(!Stage){
        if(params.get('email')){
          sendOTP(params.get('email'))
        }else{
          setStage('EMAIL')
        }
      }
    }, [params, sendOTP,Stage]);

    const submitForm = (password,otp) => {
      axios.post(URLS.password, {email: Email, password: encryptPassword(Email,password), otp, client_id}).then(res => {
            if(res){
             setStage('SUCCESS')
              setTimeout(() => {
                HISTORY.push(`/admin?origin=${origin}`)
              }, 2000);
            }
          }).catch(err => {
            showToast({
              type: 'error',
              message: err.response.data?err.response.data.message:"Invalid OTP, Retry"
            })
            setStage('PASSWORD')
        })
    }

    return (
      <div style={{overflow:'hidden'}}>
        {
            Stage==='EMAIL'
            ?<GetEmail origin={origin} onSuccess={(email)=>{sendOTP(email)}}/>
            :Stage==='PASSWORD'&&Email
            ?<NewPassword onResend={()=>{
                sendOTP(Email)
            }} origin={origin} email={Email} onSuccess={submitForm}/>
            :Stage==='SUCCESS'
            ?<div className='vh-100 w-100 d-flex justify-content-center align-content-center' style={{background:'#fff'}}>
							<div className="p-5 text-center m-auto"  data-aos="fade-up"><img className="img-fluid mb-4 m-auto" src={Tick} style={{maxWidth: '80px'}} alt=""/>
                <h1 className="display-6 fw-bold">Password Changed</h1>
                <p>Password change was successful. Login using new password.</p>
							</div>
            </div>
            :<div style={{width:'100%', height:'100vh', display: 'flex', background: '#fff', justifyContent: 'center', alignItems:'center'}}><Spinnner/></div>
        }
      </div>
    );
}

export default Index;
